import React from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import MenuIcon from 'material-ui-icons/Menu';

import { SmoothScroll } from '../layout/body/index';
import logo from '../../img/web-design-logo.png';

const styles = {
  menuIcon: {
    position: 'absolute',
    top: '50%',
    right: '0',
    transform: 'translateY(-50%)',
  },
};

const links = [
  { label: 'Contact Us', jump: 'contact-us' },
  { label: 'Services', jump: 'services' },
];

class Nav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: undefined,
      open: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleRequestCloseWithLink = this.handleRequestCloseWithLink.bind(this);
  }

  handleClick(event) {
    this.setState({ open: true, anchorEl: event.currentTarget });
  }

  handleRequestClose() {
    console.log('rofl');
    this.setState({ open: false });
  }

  handleRequestCloseWithLink(event) {
    SmoothScroll.scrollTo(event.currentTarget.dataset.jump);

    this.setState({ open: false });
  }

  render() {
    return (
      <div>
        <AppBar
          position="fixed"
          id="nav"
          color="default"
          className="app-bar"
          style={{ backgroundColor: '#FEFEFE' }}
        >
          <Toolbar>
            <div className="header">
              <div className="nav">
                <img className="logo" alt="all bits on" src={logo} />
                <IconButton
                  color="contrast"
                  aria-label="Menu"
                  style={styles.menuIcon}
                  onClick={this.handleClick}
                >
                  <MenuIcon />
                </IconButton>

                <Menu
                  id="nav-menu"
                  anchorEl={this.state.anchorEl}
                  open={this.state.open}
                  onRequestClose={this.state.handleRequestClose}
                >
                  {links.map(linkObj =>
                    (<MenuItem
                      key={linkObj.label}
                      onClick={this.handleRequestCloseWithLink}
                      data-jump={linkObj.jump}
                    >
                      {linkObj.label}
                    </MenuItem>),
                  )}
                </Menu>

              </div>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/nav/index.js